import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${props => props.theme.spacing.lg};
  padding: ${props => props.theme.spacing.md};
`;

export const Nav = styled.nav``;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.md};
`;

export const Content = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  align-items: end;
  padding: ${props => props.theme.spacing.md};
  gap: ${props => props.theme.spacing.lg};
`;

export const List = styled.section`
  padding: ${props => props.theme.spacing.md};
`;

export const SearchGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.lg};
  padding: ${props => props.theme.spacing.md};
`;

export const RadioFilters = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.md};
`;

export const OrderGroup = styled.div`
  display: grid;
  gap: ${props => props.theme.spacing.md};
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  min-width: 320px;
`;

export const ContainerBtn = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  padding: ${props => props.theme.spacing.md};
`;

export const PrevNext = styled.button<{ to: string; disabled: boolean }>`
  background-color: transparent;
  cursor: pointer;
  border: none;
  opacity: ${props => (props.disabled ? 0.3 : 1)};

  > img {
    width: 36px;
    height: 36px;
  }

  > img {
    ${props => {
      if (props.to == 'next') {
        return `
          transform: rotate(0deg);
        `;
      } else if (props.to == 'prev') {
        return `
          transform: rotate(190deg);
        `;
      }
    }}
  }
`;

export const AtualPage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border: none;
  background-color: ${props => props.theme.colors.secondary};
  border-radius: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: ${props => props.theme.colors.white};
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 100px;
`;
